/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios';
import { Fragment, useContext, useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';

import Header from '../../Components/Header/Header';
import Navbar from '../../Components/Navbar/Navbar';
import PrimaryButton from '../../Components/Buttons/PrimaryButton';
import FormInput from '../../Components/FormInput/FormInput'

import ImagePicker from '../../Components/ImagePicker/ImagePicker';
import { useHistory } from 'react-router-dom';
import { authContext } from '../../store/AuthContext';

const FloorPlans = () => {

    const serverURL = process.env.REACT_APP_SERVER_URL;
    const token = JSON.parse(localStorage.getItem('token'));

    const history = useHistory();

    const authCtx = useContext(authContext);

    if (authCtx.adminType !== 'super' && authCtx.adminType !== 'data') {
        history.push('/form');
    }

    const defaultState = {
        property: '',
        value: '',
        image: null,
        description: ''
    }

    const [floorPlans, setFloorPlans] = useState([]);
    const [properties, setProperties] = useState([]);
    const [units, setUnits] = useState([]);
    const [currProperty, setCurrProperty] = useState('');
    const [currItem, setCurrItem] = useState(defaultState);

    const getFloorPlans = async () => {

        const res = await toast.promise(
            axios({
                method: 'GET',
                url: `${serverURL}/api/floor-plan`,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }), {
            loading: 'Fetching...',
            success: 'Data fetched successfully!',
            error: 'Could not get the data.',
        }
        )
        const { data } = res.data;

        setFloorPlans(data);
    }

    const getProperties = async () => {

        const res = await toast.promise(
            axios({
                method: 'GET',
                url: `${serverURL}/api/sites`,
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }), {
            loading: 'Fetching...',
            success: 'Data fetched successfully!',
            error: 'Could not get the data.',
        }
        )

        const { data } = res.data;
        setProperties(data);
    }



    const createData = async (event) => {
        event.preventDefault();

        const formData = new FormData();

        formData.append('property', currItem.property.split('-')[0])
        formData.append('value', currItem.value.split('-')[0])
        formData.append('image', currItem.image)
        formData.append('description', currItem.description)

        const res = await toast.promise(
            axios({
                method: 'POST',
                url: `${serverURL}/api/floor-plan`,
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "multipart/form-data"
                },
                data: formData
            }), {
            loading: 'Creating...',
            success: 'Data created successfully!',
            error: 'Could not creates the data.',
        }
        )

        if (res && res.status === 200) {
            const newData = [...floorPlans];
            newData.push({
                _id: res.data.data._id,
                value: {
                    name: currItem.value.split('-')[1]
                },
                property: {
                    name: currItem.property.split('-')[1]
                },
                image: res.data.data.image,
                description: currItem.description
            })
            setFloorPlans(newData);
        }
        setCurrItem(defaultState);
        setCurrProperty("")
    }

    const deleteData = async (id) => {
        const res = await toast.promise(
            axios({
                method: 'DELETE',
                url: `${serverURL}/api/floor-plan/${id}`,
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }),
            {
                loading: 'Deleting...',
                success: "Data deleted successfully",
                error: "Couldn't delete the data"
            }
        )

        if (res && res.status === 200) {
            let newData = [...floorPlans];
            newData = newData.filter((item) => item._id !== id);
            setFloorPlans(newData);
        }
    }

    const getUnits = async (propertyID) => {
        let res = await toast.promise(
            axios({
                method: 'GET',
                url: `${serverURL}/api/units`,
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            }), {
            loading: 'Fetching...',
            success: 'Data fetched successfully!',
            error: 'Could not get the data.',
        }
        )

        let units = res.data.data;
        units = units.filter((unit) => unit.property._id === propertyID)
        setUnits(units);
    }

    const propertyChangeHandler = (event) => {
        setCurrProperty(event.target.value.split('-')[0]);
        setCurrItem((prevState) => {
            return {
                ...prevState,
                property: event.target.value
            }
        })
    }

    const unitChangeHandler = (event) => {
        setCurrItem((prevState) => {
            return {
                ...prevState,
                value: event.target.value
            }
        })
    }

    const imageChangeHandler = (file) => {
        setCurrItem((prevState) => {
            return {
                ...prevState,
                image: file
            }
        })
    }

    const decriptionChangeHandler = (event) => {
        setCurrItem((prevState) => {
            return {
                ...prevState,
                description: event.target.value
            }
        })
    }

    useEffect(() => {
        getFloorPlans();
        getProperties();
    }, [])

    useEffect(() => {
        getUnits(currProperty);
    }, [currProperty])

    return (
        <Fragment>
            <Header />
            <Navbar />
            <div className='container' >
                <div className='row'>
                    <div class="col-lg-12 mt-20">
                        <h3>Floor Plans</h3>
                        <hr />
                    </div>
                    <div className='col-lg-8'>
                        <table>
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Property</th>
                                    <th>Value</th>
                                    <th>Description</th>
                                    <th>Floor Plan</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    floorPlans.map((floorPlan, idx) => {
                                        return (
                                            <tr key={floorPlan._id} >
                                                <td>{idx + 1}</td>
                                                <td>{floorPlan.property.name}</td>
                                                <td>{floorPlan.value.name}</td>
                                                <td>{floorPlan.description}</td>
                                                <td>
                                                    <img src={`${serverURL}/${floorPlan.image}`} style={{ width: '70px' }} alt="floor plan" />
                                                </td>
                                                <td>
                                                    <div className='flex p-relative' >
                                                        <button className="delete-btn" onClick={() => deleteData(floorPlan._id)}  ><i className='fa fa-times'></i></button>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className='col-lg-4'>
                        <h5>Add Floor Plan</h5>
                        <hr />
                        <form className='user-form side-form' onSubmit={createData} >
                            <div className='form-group'>
                                <label>Select Property</label>
                                <select name='adminType' className='form-control shadow-none' value={currItem.property} onChange={propertyChangeHandler} >
                                    <option value="">Property ?</option>
                                    {
                                        properties.map((property) => {
                                            return (
                                                <option key={property._id} value={`${property._id}-${property.name}`}>{property.name}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                            <div className='form-group'>
                                <label>Select Property Unit</label>
                                <select className='form-control shadow-none' name='adminType' onChange={unitChangeHandler}  >
                                    <option value="">Value ?</option>
                                    {
                                        units.map((unit) => {
                                            return (
                                                <option key={unit._id} value={`${unit._id}-${unit.name}`}>{unit.name}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                            <FormInput onChange={decriptionChangeHandler} value={currItem.description} autoComplete='off' type='text' id='description' label='Description' />
                            {currItem.value && currItem.description.value !== 0 && <ImagePicker onChange={imageChangeHandler} id='floor=plan-image' title='Floor Plan Image' />}
                            <PrimaryButton type='submit'>
                                Add
                            </PrimaryButton>
                        </form>
                        <Fragment>
                            <br />
                            <strong>Image-Sizes in px (width x height)</strong>
                            <hr />
                            <p style={{ color: '#ed1a23' }} ><i>Floor Plan Image - 800 x 572</i></p>
                            <br />
                        </Fragment>
                    </div>
                </div>
            </div>
        </Fragment>
    )

}

export default FloorPlans;